/*
  Schiebt die kompakte Produktbox aus main-article.liquid an den Anfang des
  Artikels – vor die erste Zwischenüberschrift, frühestens aber nach zwei
  Inhaltsblöcken, damit der Leser zuerst weiß, worum es geht.

  Hintergrund: Die vollständige Produktsektion sitzt am Seitenende, bei den
  langen Ratgebern also erst nach rund 20 Bildschirmhöhen. Dort erreicht sie
  kaum jemand, obwohl der Blog gut ein Viertel des gesamten Traffics bringt.

  Ohne passenden Ankerpunkt bleibt die Box ausgeblendet – die Sektion unten
  zeigt dieselben Produkte weiterhin.
*/
(function () {
  var box = document.querySelector('[data-ap-earlybox]');
  var inhalt = document.querySelector('.article-template__content');
  if (!box || !inhalt) return;

  var kinder = inhalt.children;
  var ziel = null;

  // Erste Zwischenüberschrift, aber nicht schon im Einstieg
  for (var i = 2; i < kinder.length; i++) {
    if (/^H[234]$/.test(kinder[i].tagName)) {
      ziel = kinder[i];
      break;
    }
  }

  // Artikel ohne Zwischenüberschriften: nach dem dritten Absatz
  if (!ziel) {
    var absaetze = inhalt.querySelectorAll('p');
    if (absaetze.length >= 4) ziel = absaetze[3];
  }

  if (!ziel || !ziel.parentNode) return;

  ziel.parentNode.insertBefore(box, ziel);
  box.hidden = false;
})();
